(function () {
  var LOCK = 'data-pdp-header-lock';

  // One shared lock on page scrolling. What the body had before is kept on the body itself, so a header that
  // was swapped out while its drawer was open (the theme editor does this) cannot leave the page stuck.
  function lockScroll() {
    var body = document.body;
    if (!body.hasAttribute(LOCK)) body.setAttribute(LOCK, body.style.overflow);
    body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    var body = document.body;
    if (!body.hasAttribute(LOCK)) return;
    body.style.overflow = body.getAttribute(LOCK);
    body.removeAttribute(LOCK);
  }

  function init(root) {
    if (root.hasAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '');

    var toggle = root.querySelector('.header__icon--menu');
    var drawer = root.querySelector('.menu-drawer');
    var closeBtn = root.querySelector('.menu-drawer__close-btn');
    var focusTimer = 0;

    // Tab stays inside the open drawer, because the drawer says it is a modal dialog.
    function trapTab(e) {
      var items = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (!drawer.contains(active)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function onKey(e) {
      if (!root.isConnected) { teardown(); return; }
      if (e.key === 'Escape') close(true);
      else if (e.key === 'Tab') trapTab(e);
    }

    // The drawer is visibility:hidden until it has started to slide, so focus moves in when the slide ends.
    function focusDrawer() {
      clearTimeout(focusTimer);
      drawer.removeEventListener('transitionend', onSlideEnd);
      if (closeBtn && drawer.classList.contains('is-open')) closeBtn.focus({ preventScroll: true });
    }
    function onSlideEnd(e) { if (e.target === drawer) focusDrawer(); }

    function open() {
      if (!toggle || !drawer || drawer.classList.contains('is-open')) return;
      drawer.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      lockScroll();
      document.addEventListener('keydown', onKey);
      drawer.addEventListener('transitionend', onSlideEnd);
      focusTimer = setTimeout(focusDrawer, 300); // covers reduced motion, where no slide is reported
    }

    function close(returnFocus) {
      if (!toggle || !drawer || !drawer.classList.contains('is-open')) return;
      clearTimeout(focusTimer);
      drawer.removeEventListener('transitionend', onSlideEnd);
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      // A copy of the header that was swapped out can finish late; it must not unlock a drawer that is open now.
      if (!document.querySelector('[data-pdp-header] .menu-drawer.is-open')) unlockScroll();
      document.removeEventListener('keydown', onKey);
      if (returnFocus) toggle.focus();
    }

    if (toggle) {
      // The dark backdrop is a pseudo element of this button, so a click on the backdrop lands here too.
      toggle.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) close(true); else open();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { close(true); });
    if (drawer) {
      // Links that stay on the page (anchors) should also put the drawer away.
      drawer.addEventListener('click', function (e) {
        var link = e.target.closest ? e.target.closest('a') : null;
        if (link) close(false);
      });
    }

    // Keep the cart count current when the offer section adds to the cart.
    function setCount(n) {
      var bubble = root.querySelector('.cart-count-bubble');
      if (!bubble) return;
      var label = bubble.querySelector('span');
      if (label) label.textContent = String(n);
      bubble.hidden = !(n > 0);
    }
    function onAdded() {
      if (!root.isConnected) { teardown(); return; }
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';
      fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setCount(cart.item_count); })
        .catch(function () { /* the count refreshes on the next page load */ });
    }
    document.addEventListener('pdp:added', onAdded);

    // The theme editor removes a section before it draws the new copy. Put everything this copy set up away,
    // including the page scroll lock if the drawer was open.
    function onUnload(e) {
      if (e.target && e.target.contains && e.target.contains(root)) teardown();
    }
    function teardown() {
      close(false);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pdp:added', onAdded);
      document.removeEventListener('shopify:section:unload', onUnload);
    }
    document.addEventListener('shopify:section:unload', onUnload);
  }

  function boot() { document.querySelectorAll('[data-pdp-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
